import { render } from "./workbench.vue?vue&type=template&id=0d65c2ca&scoped=true"
import script from "./workbench.vue?vue&type=script&lang=js"
export * from "./workbench.vue?vue&type=script&lang=js"

import "./workbench.vue?vue&type=style&index=0&id=0d65c2ca&lang=scss&scoped=true"

import exportComponent from "E:\\4-6 项目\\蚂蚁电能交易分析\\energy\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d65c2ca"]])

export default __exports__